﻿import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import theme from "./Feedback.module.sass";

const FEEDBACK_TYPES = {
  error: 'error',
  info: 'info',
  success: 'success',
};

const Feedback = ({ dialogFeedback, message = '', type = FEEDBACK_TYPES.success }) => (
  <div
    className={classNames(theme.root, theme[type], {
      [theme.dialogFeedback]: dialogFeedback,
    })}
  >
    {message}
  </div>
);

Feedback.propTypes = {
  dialogFeedback: PropTypes.bool,
  message: PropTypes.node.isRequired,
  type: PropTypes.oneOf(Object.keys(FEEDBACK_TYPES)),
};

export default Feedback;
